module.exports = __webpack_public_path__ + "img/exporo_icon.93c99c77.svg";